export const countries = state => state.countries.list

export const isFetchingCountries = state => state.countries.isFetching
